import { render, staticRenderFns } from "./service-us-vn.vue?vue&type=template&id=ff8e7ba0&"
import script from "./service-us-vn.vue?vue&type=script&lang=js&"
export * from "./service-us-vn.vue?vue&type=script&lang=js&"
import style0 from "./service-us-vn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports